import React from "react";

const ProcessingBar = () => {
  return (
    <>
      <span className="loader" />
      <style>{`
        .loader {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          display: block;
          margin: 10px auto;
          position: relative;
          animation: shadowPulse 1s linear infinite;
        }

        @keyframes shadowPulse {
          33% {
            background: #FFF;
            box-shadow: -24px 0 #d09929, 24px 0 #FFF;
          }
          66% {
            background: #d09929
            box-shadow: -24px 0 #FFF, 24px 0 #FFF;
          }
          100% {
            background: #FFF;
            box-shadow: -24px 0 #FFF, 24px 0 #d09929;
          }
        }
      `}</style>
    </>
  );
};

export default ProcessingBar;
